__turbopack_context__.v({
  "cards": "DgY5kG_cards",
  "content": "DgY5kG_content",
  "headContact": "DgY5kG_headContact",
  "p": "DgY5kG_p",
  "page-body-wrap": "DgY5kG_page-body-wrap",
  "pagehero": "DgY5kG_pagehero",
  "paragraph": "DgY5kG_paragraph",
  "paragraph-content": "DgY5kG_paragraph-content",
  "phonecontent": "DgY5kG_phonecontent",
  "sectionCard": "DgY5kG_sectionCard",
  "store": "DgY5kG_store",
  "t": "DgY5kG_t",
  "title": "DgY5kG_title",
  "wrap-container": "DgY5kG_wrap-container",
  "wrap-content": "DgY5kG_wrap-content",
});
